import { render, staticRenderFns } from "./ConsumptionSanking.vue?vue&type=template&id=ed8957cc&"
import script from "./ConsumptionSanking.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionSanking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports